// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "page-component---src-pages-index-js": require("gatsby-module-loader?name=page-component---src-pages-index-js!/app/src/pages/index.js")
}

exports.json = {
  "index.json": require("gatsby-module-loader?name=path---index!/app/.cache/json/index.json")
}

exports.layouts = {
  "index": require("gatsby-module-loader?name=layout-component---index!/app/src/layouts/index")
}


// WEBPACK FOOTER //
// ./.cache/async-requires.js